"use client";

import HighlightedFeatures from "@/components/HighlightedFeatures";
import ChooseGail from "@/components/ChooseGail";
import HappyCustomers from "@/components/HappyCustomers";

export default function NotFoundProductContent() {
  return (
    <>
      <HighlightedFeatures />
      <ChooseGail />
      <HappyCustomers />
    </>
  );
}
